module.exports = __webpack_public_path__ + "img/beforeViewIcon.64fe019b.svg";